import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/sports-tree/Index.vue')
const Records = () => import('../activity/sports-tree/Records.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/sports-tree',
  name: 'activity_sports_tree',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的运动树',
  },
}

export const recordsRoute: RouteConfig = {
  path: '/activity/sports-tree/records',
  name: 'activity_sports_tree_records',
  component: Records,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '领取记录',
  },
}

export default [indexRoute, recordsRoute]
